<script lang="ts">
  import { createEventDispatcher } from "svelte";

  import { mloc } from "module/utils";
  import type { SearchFilterConfig } from "module/store/Filters";
  import FilterOptionSausage from "./FilterOptionSausage.svelte";
  import { getCompendiumTitle, getFolderTitle } from "./filterUtils";

  const {
    disabled = false,
    config,
  }: { disabled?: boolean; config: SearchFilterConfig } = $props();

  const dispatch = createEventDispatcher();

  let packTitle = $derived(getCompendiumTitle(config.compendiums));
  let folderTitle = $derived(getFolderTitle(config.folders));
</script>

<h3>{mloc("FilterEditorSectionLocationSelection")}</h3>
<ul class="selection">
  <FilterOptionSausage
    title={folderTitle}
    icon="fa-folder"
    selected={Boolean(config.folders.length)}
    more
    {disabled}
    on:click={() => dispatch("openModal", "folders")}
    on:clickMore={() => dispatch("openModal", "folders")}
  />

  <FilterOptionSausage
    title={packTitle}
    icon="fa-atlas"
    selected={Boolean(config.compendiums.length)}
    more
    {disabled}
    on:click={() => dispatch("openModal", "packs")}
    on:clickMore={() => dispatch("openModal", "packs")}
  />
</ul>

<style>
  h3 {
    padding: 0 1em 0.2em;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  }
  ul {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin: 0;
    padding: 0;
    margin-bottom: 1em;
    gap: 0.5em;
    padding: 0.4em 1em;
  }
</style>
